import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { ConverterService, LoggerService, normalizeHttpError, OccEndpointsService } from '@spartacus/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { EbRfpFormOccInterface } from '../../interfaces/eb-rfp.interface'

@Injectable()
export class EbRfpFormAdapter {

  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService
  ) {}

  send(payload: EbRfpFormOccInterface): Observable<any> {
    return this.http
      .post(this.occEndpoints.buildUrl('requestProduct'), this.toFormData(payload))
      .pipe(catchError(error => throwError(() => normalizeHttpError(error, this.logger))))
  }

  toFormData(formValue) {
    const formData = new FormData()
    if (formValue.attachment && formValue.attachment.name) {
      formData.append('attachment', formValue.attachment)
    }
    formValue.attachment = undefined
    formData.append('rfpForm', JSON.stringify(formValue))
    return formData
  }
}
